import React from "react";

import { NavigationDrawer } from "@src/components/Navigation/BaseSideNav/NavigationDrawer";

import { SettingsSideNavBarBody } from "./SettingsSideNavBarBody";

export const SettingsSideNav = () => {
  return (
    <NavigationDrawer
      isUnauthorized={false}
      hideOrgPicker={true}
      settingsPage={true}
      customBody={<SettingsSideNavBarBody />}
      customFooter={null}
    />
  );
};
